import {AbstractRepositoryV2} from '../../../../core/service/v2/abstractRepositoryV2';
import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {PartnerNote} from '../api/entity/partnerNote.model';

@Injectable({
    providedIn: 'root'
})
export class NoteRepository extends AbstractRepositoryV2<PartnerNote> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('Note', serviceElementsFactory, injector);
    }
}
